// extracted by mini-css-extract-plugin
export default {"base":"sGIPF","expander":"p7lhP","expanderExpanded":"FeXJe","footer":"Q_BrE","header":"sVPX4","fileInfo":"PYBiy","warning":"gYG7U","table":"_Lw9f"};